import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { get } from 'lodash';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import StudentEngagementTable from './StudentEngagementTable';
import { StudentEngagementListService } from '../../services/CustomerSuccessKpiListService';

class StudentEngagementTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    StudentEngagementListService.load();
  }

  render() {
    return (
      <StudentEngagementTable
        loading={
          StudentEngagementListService.fetchCurrent.fetching || StudentEngagementListService.fetchPrevious.fetching
        }
        values={toJS(
          get(StudentEngagementListService, { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type], [])
        )}
        feedbackColorRender={StudentEngagementListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={StudentEngagementListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentEngagementTableContainer);
